import React from "react";
import "./Education.css";
import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";
import { FaGraduationCap } from "react-icons/fa";

const Education = () => {
  const data = [
    {
      name: "St.Anne's High School",
      degree: "SSC",
      year: "1991-2001",
      des: "Completed high school education with honors.",
    },
    {
      name: "Niramla College",
      degree: "Bachelor's Degree in Computer Science",
      year: "2001-2003",
      des: "Excelled in programming and software development.",
    },
    {
      name: "St.Francis Institute of Technology",
      degree: "Master's Degree in Business Administration",
      year: "2003-2007",
      des: "Focused on Finance and Marketing strategies.",
    },
    {
      name: "Tech Academy",
      degree: "Certification in Web Development",
      year: "2010-2012",
      des: "Achieved proficiency in modern web technologies.",
    },
    {
      name: "Data Science ",
      degree: "Certification in Data Science",
      year: "2014-2015",
      des: "Mastered advanced data analytics and machine learning.",
    },
  ];
  const colors = ["#FF1042", "#33FF57", "#5733FF", "#4B088A", "#00C79F"];

  return (
    <div className="container education-section" id="education">
      <div className="section-title">
        <h5>Education</h5>
        <span className="line"></span>
      </div>
      <div className="">
        <VerticalTimeline lineColor="#FF1042">
          {data.map((item, index) => (
            <VerticalTimelineElement
              className="vertical-timeline-element--work"
              contentStyle={{ background: colors[index], color: "#fff" }}
              contentArrowStyle={{
                borderRight: "7px solid  rgb(33, 150, 243)",
              }}
              date={item.year}
              dateClassName="date-class"
              iconStyle={{ background: colors[index], color: "#fff" }}
              icon={<FaGraduationCap />}
            >
              <h3 className="vertical-timeline-element-title">{item.name}</h3>
              <h6 className="vertical-timeline-element-subtitle">
                {item.degree}
              </h6>

              <p>{item.des}</p>
            </VerticalTimelineElement>
          ))}
        </VerticalTimeline>
      </div>
    </div>
  );
};

export default Education;